const initialeState = {
    printScreenCapt: null,
    printState: false,
    openPrintControl: false,
}


const PrintReducer = (state=initialeState, action) => {
    switch (action.type) {
        case  'UPDATE_SCREEN_CAPTURE':
            return {
                ...state,
                printScreenCapt: action.data.printScreenData
            }
        case  'TOGGLE_PRINT_STATE':
            return {
                ...state,
                printState: action.data
            }
        case  'OPEN_PRINT_CONTROL':
            return {
                ...state,
                openPrintControl: action.data
            }
        default:
            return state
    }
}

export default PrintReducer
